import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const Step = ({ n, text }) => (
  <div className="flex gap-3">
    <div className="w-6 h-6 rounded-full bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-400 text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5">{n}</div>
    <p className="text-sm text-gray-700 dark:text-gray-300">{text}</p>
  </div>
);

const QA = ({ q, a }) => (
  <div>
    <p className="text-xs text-gray-400 dark:text-gray-500 mb-0.5">Q. {q}</p>
    <p className="text-sm text-gray-700 dark:text-gray-300">→ {a}</p>
  </div>
);

const sections = [
  {
    title: '앱 가입하기',
    content: (
      <div className="space-y-3">
        <Step n={1} text="로그인 화면 → '헬스장 회원이신가요? 앱 가입하기' 버튼을 누르세요." />
        <Step n={2} text="헬스장에서 받은 6자리 매장 코드를 입력하세요." />
        <Step n={3} text="전화번호를 입력하세요. 이미 등록된 회원이면 비밀번호 설정, 신규라면 정보를 입력 후 신청합니다." />
        <Step n={4} text="관리자 승인 후 앱을 이용하실 수 있습니다." />
      </div>
    ),
  },
  {
    title: '회원권 확인',
    content: (
      <div className="space-y-3">
        <QA q="내 회원권은 어디서 확인하나요?" a="하단 탭 '회원권' 메뉴에서 현재 이용 중인 회원권과 만료일을 확인할 수 있습니다." />
        <QA q="회원권 연장은 어떻게 하나요?" a="회원권 페이지에서 '연장 신청' 버튼을 누르면 관리자에게 신청이 전달됩니다. 결제 후 관리자가 처리합니다." />
        <QA q="회원권이 만료됐어요" a="연장 신청 버튼을 눌러 신청하거나 헬스장에 직접 문의하세요." />
      </div>
    ),
  },
  {
    title: '출석 & QR',
    content: (
      <div className="space-y-3">
        <QA q="QR 출석은 어떻게 하나요?" a="하단 탭 'QR' 메뉴에서 QR코드를 꺼내 직원에게 보여주세요." />
        <QA q="내 출석 기록은 어디서 볼 수 있나요?" a="하단 탭 '출석' 메뉴에서 날짜별 출석 기록을 확인할 수 있습니다." />
      </div>
    ),
  },
  {
    title: 'PT 관리',
    content: (
      <div className="space-y-3">
        <QA q="내 PT 잔여 횟수는?" a="하단 탭 'PT' 메뉴에서 등록된 PT와 잔여 횟수를 확인할 수 있습니다." />
        <QA q="PT 일정은 어디서 보나요?" a="PT 메뉴 → 예정 일정 탭에서 트레이너가 등록한 앞으로의 PT 일정을 확인할 수 있습니다." />
        <QA q="PT 일지는 어디서 보나요?" a="PT 메뉴에서 각 PT 항목을 클릭하면 트레이너가 기록한 일지를 볼 수 있습니다." />
        <QA q="내 신체 정보는 어디서 보나요?" a="하단 탭 '내 신체 정보' 메뉴에서 트레이너가 기록한 체중, 체지방 등의 변화를 그래프로 확인할 수 있습니다." />
      </div>
    ),
  },
  {
    title: '내 정보 관리',
    content: (
      <div className="space-y-3">
        <QA q="전화번호나 주소를 변경하려면?" a="'내 정보' 탭 → '수정 요청' 버튼 → 변경할 내용 입력 → 신청. 관리자 승인 후 반영됩니다." />
        <QA q="비밀번호를 변경하려면?" a="'내 정보' 탭 → 계정 정보 → '비밀번호 변경'" />
        <QA q="로그아웃하려면?" a="'내 정보' 탭 맨 아래 로그아웃 버튼" />
      </div>
    ),
  },
];

export default function MemberHelp() {
  const [openSection, setOpenSection] = useState(0);

  return (
    <div className="p-4 space-y-3">
      <h2 className="text-base font-bold text-gray-900 dark:text-white mb-4">도움말</h2>
      {sections.map((section, idx) => {
        const isOpen = openSection === idx;
        return (
          <div
            key={idx}
            className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden"
          >
            <button
              onClick={() => setOpenSection(isOpen ? -1 : idx)}
              className="w-full flex items-center justify-between px-5 py-4 text-left"
            >
              <span className="font-semibold text-gray-900 dark:text-white text-sm">{section.title}</span>
              <ChevronDown
                className={`w-4 h-4 text-gray-400 transition-transform flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`}
              />
            </button>
            {isOpen && (
              <div className="px-5 pb-5 border-t border-gray-100 dark:border-gray-700 pt-4">
                {section.content}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
